import { getYear, parseISO } from 'date-fns'

export const getYearFromDate = (date) => {
  // Handle null/undefined
  if (!date) {
    return null
  }
  
  // If it's already a Date object, use it directly
  if (date instanceof Date) {
    return getYear(date)
  }
  
  // If it's a string, try to parse it with parseISO first, fallback to direct Date constructor
  if (typeof date === 'string') {
    try {
      const parsedDate = parseISO(date)
      // Check if parseISO succeeded by verifying it's a valid date
      if (parsedDate instanceof Date && !isNaN(parsedDate.getTime())) {
        return getYear(parsedDate)
      }
    } catch (error) {
      // parseISO failed, try with Date constructor
    }
    
    // Fallback: try creating Date directly from string
    const fallbackDate = new Date(date)
    if (!isNaN(fallbackDate.getTime())) {
      return getYear(fallbackDate)
    }
  }
  
  // If we reach here, we couldn't parse the date
  return null
}
